import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import Page from 'components/Page'
import commonContent from 'prismic-translates/common.json'
import otpHelloAgainContent from 'prismic-translates/dialog-otp-hello-again.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([commonContent, otpHelloAgainContent])

export default function NotAvailableLocation() {
  return (
    <Page className={classes.classNameRoot}>
      <div className={classes.root}>
        <div className={classes.content}>
          <img
            className={classes.locationImage}
            src={`${process.env.IMG_ORIGIN}/not_available_location.svg`}
            alt='not available location'
          />
          <h3 className={classes.title}>
            {t('not_available_location_part_1')}{' '}
            <span className={classes.brand_name_text}>{t(`${process.env.BRAND_NAME}_name`)}</span>{' '}
            {t('not_available_location_part_2')}
          </h3>
          <span className={classes.text}>
            {t('got_questions')} <a href={`${process.env.ZENDESK_SUPPORT_LINK}`}>{t('contact_us')}</a>
          </span>
        </div>
      </div>
    </Page>
  )
}
